<template>
    <b-col :class="computedBackground">
        <b-row>
            <b-col :key="index" align="center" class="pmis-image justify-content" v-bind="img.sizes" v-for="(img, index) in images">
                <img :src="img.src" class="img-fluid"/>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    import {pmisColorsMixin} from "../../mixins/pmis-colors-mixin";

    export default {
        name: "PmisPresentationImageContainer",
        props: {
            name: String,
            images: Array
        },
        mixins: [pmisColorsMixin]
    }
</script>

<style lang="scss" scoped>
    .pmis-image {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
    }
</style>
